import { LinkButton, tvar } from '@versita/frontend/campus-ui-web';
import styled from 'styled-components';

export const StyledCourseTimetableSubheading = styled.span`
  display: flex;
  align-items: center;
  margin-bottom: ${tvar('space.x2')};

  &:not(:first-child) {
    margin-top: ${tvar('space.x2')};
  }
  a {
    text-decoration: none;
  }
`;

export const StyledCourseTimetableCourseYear = styled.span`
  display: inline;
  font-weight: 300;
  text-transform: capitalize;
  font-size: ${tvar('typographies.h2.fontSize')};
  line-height: 1;
  margin: 0;
`;

export const StyleDesktopTimetableHeaderButton = styled(LinkButton)`
  display: none;
  font-weight: normal;
  border-width: 0.2rem;
  font-size: ${tvar('typographies.small.fontSize')};
  padding: calc(${tvar('space.half')} * 1.5) calc(${tvar('space.single')} * 1.5);
  margin-left: ${tvar('space.x2')};
  align-self: flex-start;

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    display: block;
  }
`;

export const StyledMobileTimetableHeaderButton = styled(LinkButton)`
  margin-top: ${tvar('space.x2')};
  font-weight: normal;

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    display: none;
  }
`;
